import { IJxtResourceTabHeader } from './types';
import { useTranslation } from 'react-i18next';
import JxtStar from '../JxtStar';
import { JxtStarSizeEnum, JxtStarTypeEnum } from '../JxtStar/types';
import { useRef } from 'react';

const JxtResourceTabHeader = ({
  name,
  id,
  type,
  capacity,
  isFavorite = false,
  onToggleFavorite,
  shouldCenter = false,
}: IJxtResourceTabHeader) => {
  const { t } = useTranslation();
  const starRef = useRef<SVGSVGElement>(null);

  return (
    <header className="w-full justify-between flex text-center">
      <div style={{ width: shouldCenter ? starRef?.current?.getBoundingClientRect().width : 0 }} />
      <div className="truncate">
        <h3 title={name} className="text-neutral-140 font-medium truncate px-6">
          {name}
        </h3>
        <h4 className="text-center text-body-s text-neutral-80 font-normal">
          {type}&nbsp;({capacity} {t('resource-person')})
        </h4>
      </div>
      <JxtStar
        ref={starRef}
        checked={isFavorite}
        type={JxtStarTypeEnum.Light}
        size={JxtStarSizeEnum.Large}
        disabled={false}
        onClick={(e: boolean) => (id ? onToggleFavorite?.(e, id, 'Spaces') : undefined)}
      />
    </header>
  );
};

export default JxtResourceTabHeader;
